<template>
  <div class="apply_box">
    <div class="header">
      <div class="loanMoney">本期还款金额（元)</div>
      <p class="title">¥ {{list.amount}}</p>
      <p class="limit">{{list.periodDesc}}</p>
    </div>
    <div class="bg"></div>
    <div class="pro_item1"
         v-if="type==2">
      <span class="label">手机号码</span>
      <input type="text"
             placeholder="请输入手机号码"
             class="inputStyle1"
             v-model='phone'
             readOnly>
    </div>
    <div class="pro_item1 noborder mb"
         v-if="type==2">
      <span class="label">短信验证</span>
      <input type="text"
             placeholder="请输入验证码"
             v-model='vertifyCode'
             class="inputStyle">
      <span v-if="!cutStart"
            class="replace_btn right"
            @click="getMsgCode">获取验证码</span>
      <span v-if="cutStart"
            class="replace_btn right cc">剩余{{second}}s</span>
    </div>
    <p class="repe_info"><span class="tip_icon"></span>还款前请确认绑定银行卡内余额充足</p>

    <div class="btn_box">
      <div class="loan_btn pay_btn_succ"
           @click="checkMsgCode">确认还款</div>
    </div>
    <applyModal :propJson="propJson"
                @pageUrl="pageUrl" />
    <Loading :isShow="isShowLoading"></Loading>
  </div>
</template>

<script>
import Loading from '@/components/loading';
import applyModal from '@/components/applyModal';
export default {
  components: {
    applyModal,
    Loading
  },
  data () {
    return {
      isShowLoading: false,
      phone: '',
      vertifyCode: '',
      second: 59,
      cutStart: false,
      propJson: {
        isShow: false,
        title: '还款申请成功',
        info: '机构将从绑定的还款卡中划扣本期金额，还款结果以银行卡流水为准，请注意查看',
        btn: '我知道啦',
        status: '1'
      },
      allList: [],
      orderId: '',
      orderList: [],
      bigList: [],
      bigJson: {},
      cardList: [],
      cardJson: {},
      buttonList: [],
      footList: [],
      footJson: [],
      type: '',
      list: {}
    }
  },
  mounted () {
    this.orderId = this.$route.query.orderId;
    this.type = this.$route.query.type;
    this.util.title('主动还款');
    this.getDetails()
  },
  methods: {
    pageUrl () {
      this.propJson.isShow = false;
      this.$router.push({
        path: '/loan/applyStatus',
        query: {
          orderType: 2
        }
      })
    },
    checkMsgCode () {//获取验证码
      let _this = this;
      let param = {};
      if (_this.vertifyCode == "" && _this.type == 2) {
        _this.util.toast({ msg: '请输入验证码' })
        return false;
      }
      _this.isShowLoading = true;
      param.verifyCode = _this.verifyCode;
      param.orderId = _this.orderId;
      this.$post('/app/api/v1/refund/checkCode', param).then(res => {
        if (res.code == 200) {
          this.propJson.isShow = true;
        } else {
          this.propJson = {
            isShow: true,
            title: '还款申请失败',
            info: res.message,
            btn: '确定',
            status: '0'
          }
          // this.util.toast({ msg: res.message, type: 'fail' })
        }
        _this.isShowLoading = false;
      });
    },
    getMsgCode () {//获取验证码
      let _this = this;
      let param = {};
      this.$post('/app/api/v1/refund/sendCode', {
        orderId: _this.orderId,
      }).then(res => {
        if (res.code == 200) {
          this.cutdown();
        } else {
          this.util.toast({ msg: res.message, type: 'fail' })
        }
      });
    },
    cutdown () {//倒计时
      this.cutStart = true;
      if (this.second == 0) {
        this.cutStart = false;
        this.second = 59;
        return;
      } else {
        this.second = this.second - 1;
        setTimeout(() => {
          this.cutdown();
        }, 1000)
      }
    },
    toShow () {
      this.propJson.isShow = true;
    },
    getDetails () {
      let _this = this;
      this.$get('/app/api/v1/order/repay/info/' + this.orderId, {})
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.list = e.data;
            _this.phone = e.data.phone;
          }
          else {
            _this.util.toast({ msg: e.msg })
          }
        })
        .catch(error => { });
    },
    //去分期
    toPage (pageUrl) {
      this.propJson.isShow = true;
      return false;
      if (pageUrl == '') {
        this.util.toast({ msg: '请先完成绑卡，若已绑卡请2分钟后再签约' })
      } else {
        window.location.href = pageUrl;
      }
    },
    checkStatus () {
      this.isActive = !this.isActive;
    }
  }
}
</script>
<style scoped>
.apply_box {
  background: #f7f7f7;
  padding-bottom: 0.2rem;
}
.bg {
  background: #f7f7f7;
  width: 100%;
  height: 0.1rem;
}
.header {
  padding: 0.14rem 0.15rem;
  /* margin-bottom: 0.1rem; */
  background: #ffffff;
  padding-bottom: 0.04rem;
}
.loanMoney {
  color: #999;
  font-size: 0.12rem;
}
.pro_detail {
  background: #ffffff;
  /* margin-bottom: 0.1rem; */
}
.title {
  color: #333;
  font-size: 0.35rem;
  font-family: DINAlternate-Bold;
  font-weight: bold;
  border-bottom: 1px solid #f5f5f5;
}
.limit {
  font-size: 0.12rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: #999;
  margin-top: 0.1rem;
}
.pro_item {
  padding: 0.15rem;
  border-bottom: 1px solid #eee;
  display: flex;
  flex: 1;
  justify-content: space-between;
  color: #666;
  font-size: 0.14rem;
}
.pro_item .btn {
  color: #486cff;
  font-size: 0.14rem;
  text-align: center;
  margin: 0 auto;
  padding: 0.1rem;
}
.h1 {
  font-size: 0.14rem;
  color: #333;
  font-family: PingFangSC-Medium;
  font-weight: 500;
}
.line {
  display: inline-block;
  width: 3px;
  height: 0.12rem;
  background: #486cff;
}
.info_box {
  font-size: 0.11rem;
  color: #333;
  padding: 0.1rem 0.15rem 0.36rem 0.15rem;
  background: #f7f7f7;
}
.info_box .agree {
  color: #486cff;
}
.icon_circle,
.icon_circleAct {
  position: relative;
  top: 0.02rem;
  margin-right: 0.05rem;
  display: inline-block;
  width: 0.14rem;
  height: 0.14rem;
  background: url("../../assets/img/afterLoan/choice_unCheck.png") no-repeat top
    center;
  background-size: 100% 100%;
}
.icon_circleAct {
  background: url("../../assets/img/afterLoan/checked.png") no-repeat top center;
  background-size: 100% 100%;
}
.bank_btn {
  display: inline-block;
  width: 0.14rem;
  height: 0.14rem;
  background: url("../../assets/img/afterLoan/add_btn.png") no-repeat top center;
  background-size: 100% 100%;
  margin: 0 auto;
  text-align: center;
  margin-right: 0.1rem;
  position: relative;
  top: 0.02rem;
}
.loan_btn {
  color: #fff;
  background: linear-gradient(
    90deg,
    rgba(122, 157, 246, 0.5) 0%,
    rgba(81, 117, 241, 0.5) 100%
  );
  box-shadow: 0px 6px 10px 0px rgba(228, 238, 250, 1);
  border-radius: 25px;
  height: 0.5rem;
  line-height: 0.5rem;
  font-size: 0.17rem;
  text-align: center;
  line-height: 0.5rem;
  width: 90%;
  margin: 0 auto;
}

.pay_btn_succ {
  background: linear-gradient(
    90deg,
    rgba(122, 157, 246, 0.8) 0%,
    rgba(81, 117, 241, 1) 100%
  );
}
.look {
  color: #486cff;
  font-size: 0.13rem;
  float: right;
}
.btn_box {
  margin-top: 0.3rem;
}
.pro_item1 {
  padding: 0.15rem;
  clear: both;
  overflow: hidden;
}
.tip_icon {
  display: inline-block;
  width: 0.12rem;
  height: 0.12rem;
  background: url("../../assets/img/afterLoan/icon_tips.png") no-repeat top
    center;
  background-size: 100% 100%;
  position: relative;
  top: 0.01rem;
  margin-right: 0.05rem;
}
.look_icon {
  display: inline-block;
  width: 0.06rem;
  height: 0.1rem;
  background: url("../../assets/img/afterLoan/look_right.png") no-repeat top
    center;
  background-size: 100% 100%;
}
.replace_btn {
  color: #486cff;
  font-size: 0.14rem;
  padding: 0.15rem;
  padding: 0.15rem 0;
}
.cc {
  color: #ccc;
}
.pro_item1 {
  clear: both;
  overflow: hidden;
  padding: 0 0.15rem;
  background: #fff;
  border-bottom: 1px solid #f5f5f5;
}
.noborder {
  border: None;
}
.mb {
  margin-bottom: 0.1rem;
}
.repe_info {
  color: #333;
  font-size: 0.12rem;
  padding-left: 0.15rem;
  /* margin-top: 0.17rem; */
  margin-bottom: 0.49rem;
}
.label {
  font-size: 0.14rem;
  color: #666;
  display: inline-block;
  width: 0.75rem;
}
.inputStyle,
.inputStyle1 {
  padding: 0.15rem;
  color: #333;
  font-size: 0.14rem;
  width: 74%;
  font-family: PingFangSC-Regular;
  font-weight: 400;
}
.inputStyle {
  width: 50%;
}
</style>